import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { apiJson } from '../lib/api.js';
import { useAuth } from '../lib/auth.jsx';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const { user, refresh } = useAuth();
  const token = params.get('token');
  const fresh = params.get('fresh') === '1';
  const [status, setStatus] = useState(token ? 'verifying' : 'idle');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) return;
    apiJson('/api/auth/verify-email', { method: 'POST', body: { token } })
      .then(async () => {
        setStatus('done');
        await refresh();
      })
      .catch((e) => {
        setStatus('error');
        setError(e.message);
      });
  }, [token, refresh]);

  const resend = async () => {
    setStatus('resending');
    try {
      await apiJson('/api/auth/resend-verification', { method: 'POST' });
      setStatus('resent');
    } catch (e) {
      setStatus('error');
      setError(e.message);
    }
  };

  return (
    <div
      style={{
        padding: 40,
        minHeight: '100vh',
        background: 'var(--bg, #f7f5fc)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 18,
          padding: '32px 36px',
          boxShadow: '0 18px 48px rgba(20, 5, 60, 0.08)',
          border: '1px solid var(--border, #ece8f6)',
          maxWidth: 480,
          width: '100%',
          marginTop: 40,
        }}
      >
        <div style={{ fontSize: 12, fontWeight: 700, color: '#5b21b6', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: 8 }}>
          Email verification
        </div>

        {status === 'idle' && (
          <>
            <h1 style={{ margin: '0 0 8px', fontSize: 24 }}>
              {fresh ? 'Welcome to Medic Mind' : 'Verify your email'}
            </h1>
            <p style={{ color: '#6b7280', lineHeight: 1.6 }}>
              {fresh
                ? 'We sent a verification link to your inbox. Click it to confirm your email and unlock everything.'
                : 'Open the link we sent to verify your email. Check spam/junk if you can\'t find it.'}
            </p>
            {user && (
              <button
                onClick={resend}
                style={{
                  marginTop: 18,
                  padding: '10px 16px',
                  borderRadius: 10,
                  border: '1px solid #5b21b6',
                  background: '#fff',
                  color: '#5b21b6',
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                Resend verification email
              </button>
            )}
          </>
        )}

        {status === 'verifying' && <p>Verifying your email…</p>}

        {status === 'done' && (
          <>
            <h1 style={{ margin: '0 0 8px', fontSize: 24, color: '#15803d' }}>You're verified ✓</h1>
            <p style={{ color: '#6b7280' }}>Your email is now confirmed.</p>
            <Link to="/" style={{ display: 'inline-block', marginTop: 14, color: '#5b21b6', fontWeight: 600 }}>
              Continue to Medic Mind →
            </Link>
          </>
        )}

        {status === 'resent' && (
          <p style={{ color: '#15803d' }}>A fresh verification email is on its way.</p>
        )}

        {status === 'error' && (
          <>
            <h1 style={{ margin: '0 0 8px', fontSize: 24, color: '#991b1b' }}>Verification failed</h1>
            <p style={{ color: '#6b7280' }}>{error || 'The link is invalid or expired.'}</p>
            {user && (
              <button
                onClick={resend}
                style={{
                  marginTop: 14,
                  padding: '10px 16px',
                  borderRadius: 10,
                  border: '1px solid #5b21b6',
                  background: '#fff',
                  color: '#5b21b6',
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                Send me a new link
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
